import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormFileUploadModule } from '@lib/form/file-upload';
import { SnNotificationUsersModule } from '@lib/notification-users';
import { SnVideoPlayerModule } from '@lib/player/video-player';
import { SnSchedulerModule } from '@lib/scheduler';
import { TranslationModule } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';
import { VaultModule } from '@lib/vault';
import { SnImagePlayerModule } from 'libs/player/image-player/src/lib/image-player.module';
import { SnButtonModule } from 'libs/ui/button/src/lib/button.module';
import { SnDrawerModule } from 'libs/ui/drawer/src/lib/drawer.module';

import { AiBoxComponent } from './components/ai-box/ai-box.component';
import { AiBoxesComponent } from './components/ai-boxes/ai-boxes.component';
import { AiDetectionPopupComponent } from './components/ai-detection-popup/ai-detection-popup.component';
import { ClipViewVideoDialogComponent } from './components/clip-view-video-dialog/clip-view-video-dialog.component';
import { CreateSentryDialogComponent } from './components/create-sentry-dialog/create-sentry-dialog.component';
import { DetectionDetailsDialogComponent } from './components/detection-details-dialog/detection-details-dialog.component';
import { SentryCameraDialogComponent } from './components/sentry-camera-dialog/sentry-camera-dialog.component';
import { SentryCameraPopupComponent } from './components/sentry-camera-popup/sentry-camera-popup.component';
import { SentryResultsComponentComponent } from './components/sentry-results-component/sentry-results-component.component';
import { SentryScheduleDialogComponent } from './components/sentry-schedule-dialog/sentry-schedule-dialog.component';
import { SentrySearchFormDrawerComponent } from './components/sentry-search-form-drawer/sentry-search-form-drawer.component';
import { SentrySearchPaginationComponent } from './components/sentry-search-pagination/sentry-search-pagination.component';
import { SentrySearchResultsDrawerComponent } from './components/sentry-search-results-drawer/sentry-search-results-drawer.component';
import { SnapAiImageDialogComponent } from './components/snap-ai-image-dialog/snap-ai-image-dialog.component';
import { SnapAiRadarComponent } from './components/snap-ai-radar/snap-ai-radar.component';
import { SnapAiSelectorComponent } from './components/snap-ai-selector/snap-ai-selector.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SnFormModule,
    SnFormFileUploadModule,
    SnIconModule,
    SnButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatTooltipModule,
    NgxSliderModule,
    NgxLoadingButtonsModule,
    SnCommonModule,
    SnImagePlayerModule,
    SnVideoPlayerModule,
    SnDrawerModule,
    SnSchedulerModule,
    MatButtonModule,
    SnNotificationUsersModule,
    VaultModule,
    TranslationModule,
  ],
  exports: [
    SnapAiSelectorComponent,
    SnapAiRadarComponent,
    SnapAiImageDialogComponent,
    CreateSentryDialogComponent,
    SentryScheduleDialogComponent,
    AiBoxComponent,
    AiBoxesComponent,
    DetectionDetailsDialogComponent,
    SentryCameraDialogComponent,
    SentryCameraDialogComponent,
    SentryResultsComponentComponent,
    SentrySearchFormDrawerComponent,
    SentrySearchPaginationComponent,
    SentrySearchResultsDrawerComponent,
    AiDetectionPopupComponent,
  ],
  declarations: [
    SnapAiSelectorComponent,
    SnapAiRadarComponent,
    SnapAiImageDialogComponent,
    CreateSentryDialogComponent,
    SentryScheduleDialogComponent,
    AiBoxComponent,
    AiBoxesComponent,
    DetectionDetailsDialogComponent,
    SentryCameraDialogComponent,
    SentryCameraDialogComponent,
    SentryResultsComponentComponent,
    SentrySearchFormDrawerComponent,
    SentrySearchPaginationComponent,
    SentrySearchResultsDrawerComponent,
    SentryCameraPopupComponent,
    ClipViewVideoDialogComponent,
    AiDetectionPopupComponent,
  ],
})
export class FsSentryModule {}
